export default {
    apiKey: "AIzaSyDil5em-9hL36eUBZ0Axy2W6rvJQePbt_4",
    authDomain: "conntest-6e6fd.firebaseapp.com",
    databaseURL: "https://conntest-6e6fd.firebaseio.com",
    projectId: "conntest-6e6fd",
    storageBucket: "conntest-6e6fd.appspot.com",
    messagingSenderId: "710268755509"
}